export const HERMES_SERVICES = [
    {
        label: 'Standard',
        value: 'standard',
    },
];

export const HERMES_DELIVERED_CODES = ['DLVRD'];
